export default function DropdownSelectValidator() {
    return {
        restrict: 'A',
        priority: 1,
        require: ['ngModel'],
        link: function($scope, $elem, $attrs, [ngModelCtrl]) {
            const placeholder = $scope.$eval($attrs.placeholder);
            $scope.$watch(getModelValue, validate, true);

            function validate(value) {
                validateRequired(value);
            }

            function validateRequired(value) {
                let isFilled;
                if (placeholder) {
                    isFilled = value && !angular.equals(value, placeholder);
                } else {
                    isFilled = value && Object.keys(value).length > 0;
                }
                ngModelCtrl.$setValidity('required', isFilled);
            }

            function getModelValue() {
                return $scope.$eval($attrs.dropdownModel);
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/dropdown-select-validator.js